"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSubscriptionStatus = exports.GroupType = void 0;
var GroupType;
(function (GroupType) {
    GroupType["ADVERTISER"] = "advertiser";
    GroupType["AD_AGENCY"] = "ad_agency";
    GroupType["PRODUCTION_COMPANY"] = "production_company";
    GroupType["TALENT"] = "talent";
    GroupType["TALENT_AGENCY"] = "talent_agency";
})(GroupType || (exports.GroupType = GroupType = {}));
var GroupSubscriptionStatus;
(function (GroupSubscriptionStatus) {
    GroupSubscriptionStatus["PENDING_PAYMENT"] = "pending_payment";
    GroupSubscriptionStatus["TRIALING"] = "trialing";
    GroupSubscriptionStatus["ACTIVE"] = "active";
    GroupSubscriptionStatus["PAST_DUE"] = "past_due";
    GroupSubscriptionStatus["CANCELED"] = "canceled";
})(GroupSubscriptionStatus || (exports.GroupSubscriptionStatus = GroupSubscriptionStatus = {}));
//# sourceMappingURL=group-types.js.map